import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "19",
  viewBox: "0 0 21 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Find-Friends" }, [
      _createElementVNode("g", { id: "Group" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C8.53043 2 9.03914 2.21071 9.41421 2.58579C9.78929 2.96086 10 3.46957 10 4C10 4.53043 9.78929 5.03914 9.41421 5.41421C9.03914 5.78929 8.53043 6 8 6C6.89 6 6 5.11 6 4C6 2.89 6.9 2 8 2ZM7.27 16H0V13C0 10.33 5.33 9 8 9C9.04 9 10.5 9.21 11.86 9.61C11 9.95 10.2 10.42 9.5 11C9 10.94 8.5 10.9 8 10.9C5.03 10.9 1.9 12.36 1.9 13V14.1H7.22C7.2 14.15 7.17 14.2 7.14 14.25L6.85 15L7.14 15.75C7.18 15.83 7.23 15.91 7.27 16ZM15 14C15.56 14 16 14.44 16 15C16 15.56 15.56 16 15 16C14.44 16 14 15.56 14 15C14 14.44 14.44 14 15 14ZM15 11C12.27 11 9.94 12.66 9 15C9.94 17.34 12.27 19 15 19C17.73 19 20.06 17.34 21 15C20.06 12.66 17.73 11 15 11ZM15 17.5C14.337 17.5 13.7011 17.2366 13.2322 16.7678C12.7634 16.2989 12.5 15.663 12.5 15C12.5 14.337 12.7634 13.7011 13.2322 13.2322C13.7011 12.7634 14.337 12.5 15 12.5C15.663 12.5 16.2989 12.7634 16.7678 13.2322C17.2366 13.7011 17.5 14.337 17.5 15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5Z",
          fill: "currentColor"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }